import { TAGS_URL } from '@/modules/tag/tag.constants';
import * as tagResource from '@/modules/tag/tag.resource';

export function fetchTags(pagination = {}) {
  return new Promise((resolve, reject) =>
    tagResource
      .fetchTags(pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => reject(err)));
}

export function fetchFollowed(pagination = {}) {
  return new Promise((resolve, reject) =>
    tagResource
      .fetchFollowed(pagination)
      .then(({ data }) => {
        resolve({
          data: data.data,
          pagination: {
            page: data.page,
            total: parseInt(data.total),
          },
        });
      })
      .catch(err => reject(err)));
}

export function fetchTagById(id) {
  return new Promise((resolve, reject) =>
    tagResource
      .fetchTagById(id)
      .then(({ data }) => {
        resolve({ data });
      })
      .catch(err => reject(err)));
}

export function searchTag(search) {
  return new Promise((resolve, reject) =>
    tagResource
      .searchTag(search)
      .then(({ data }) => {
        resolve({ data });
      })
      .catch(err => reject(err)));
}

export function getTagUser(tag) {
  return new Promise((resolve, reject) =>
    tagResource.getTagUser(tag)
      .then(({ data }) => resolve(data))
      .catch(err => reject(err)));
}

export function followTag(tag) {
  return new Promise((resolve, reject) =>
    tagResource.followTag(tag)
      .then(({ data }) => resolve(data))
      .catch(err => reject(err)));
}

export function unfollowTag(tag) {
  return new Promise((resolve, reject) =>
    tagResource.unfollowTag(tag)
      .then(({ data }) => resolve(data))
      .catch(err => reject(err)));
}

export function saveTag(tag) {
  return new Promise((resolve, reject) =>
    tagResource.saveTag(tag)
      .then(({ data }) => resolve(data))
      .catch(err => reject(err)));
}

export function saveTagsFromContent(content) {
  const tags = content.match(/#[^#\s]+/gi);
  if (tags) {
    const promises = tags.map((hashtag, i) => {
      tags[i] = hashtag.slice(1, undefined);
      return saveTag({ name: tags[i] })
        .then(data => {
          tags[i] = data;
        });
    });
    return new Promise((resolve, reject) => {
      Promise.all(promises)
        .then(() => resolve(tags))
        .catch(reject);
    });
  }
  return null;
}

export function getTagLink(tag) {
  return {
    name: TAGS_URL.view.name,
    path: TAGS_URL.view.path,
    params: { id: tag.id },
  };
}
